import styled from 'styled-components';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import {Input, Button, Space, Spin, message, Menu, Dropdown} from 'antd';
import {Fragment, Suspense, useCallback, useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';

import nav_list from './nav_list';
import { useDispatch, useSelector } from 'react-redux';
import { currentToken, currentUser } from '../../../../features/user/userSlice';
import UserInfo from './UserMenu.js';
import {
  // currentKeyword,
  setKeyword,
} from '../../../../features/search/searchSlice';

import logoPNG from '../../../../assets/images/logo.png';

import {SearchIcon, EnterIcon} from '../../../../icons';
import CompanyIcon from '../../../../assets/images/icons/company@2x.png';
import UserIcon from '../../../../assets/images/icons/user.png';

const { Search } = Input;

const NavListContainer = styled.ul`
  margin: 0;
  display: flex;
  list-style: none;
  padding-left: 0;
  & > a {
    padding: 0 17px;
    color: #fff;
  }
`;

// const activeStyle = {
//   color: '#333',
//   background: '#ccc',
// };

const NavList = () => {
  const { t } = useTranslation();
  return (
    <NavListContainer>
      {nav_list.map((item) => {
        return (
          <NavLink
            to={item.link}
            key={item.link}
            className={({ isActive }) =>
              isActive ? 'active-link default-link' : 'default-link'
            }
          >
            <span
              style={{
                fontWeight: '500',
              }}
            >
              {t(item.tag)}
            </span>
          </NavLink>
        );
      })}
    </NavListContainer>
  );
};

const LOGOContainer = styled.div`
  cursor: pointer;
`;

const LOGOImage = styled.img`
  width: 72px;
`;

const Logo = () => {
  const navigate = useNavigate();
  return (
    <LOGOContainer>
      <LOGOImage
        src={logoPNG}
        onClick={() => {
          navigate('/');
        }}
      />
    </LOGOContainer>
  );
};

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation()

  return (
    <Button
      style={{
        color:'#fff',
      }}
      type="text"
      size="small"
      onClick={() => {
        navigate('/login?redirect_url='+location.pathname, { replace: true });
      }}
    >
      {t('login')}
    </Button>
  );
};

const DropdownButton = styled.a`
  color: #fff;
  &:hover,
  &:focus,
  &:visited {
    color: #fff;
  }
`

const Register = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const menu = (
      <Menu items={[{
        label: t('whiteHat'),
        key: 1,
        icon: <img width={10} height={12}  src={UserIcon} alt={t('whiteHat')} />,
          onClick: () => {
              navigate('/register', { replace: true });
          }
      }, {
        label: t('project'),
        key: 2,
          icon: <img width={12} height={12} src={CompanyIcon} alt={t('project')} />,
          onClick: () => {
              navigate('/project/register', { replace: true });
          }
      }]}>
      </Menu>
  )

  return (
      <div>
          <Dropdown trigger='hover' overlay={menu}>
              <DropdownButton onClick={e => e.preventDefault()}>
                  <Space>
                      {t('register')}
                      <DownOutlined />
                  </Space>
              </DropdownButton>
          </Dropdown>
      </div>
  )
};

// const UserInfo = () => {
//   const token = useSelector(currentToken);
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   return (
//     <Button
//       size="small"
//       onClick={() => {
//         navigate('/user');
//       }}
//     >
//       {t('user')}
//     </Button>
//   );
// };

const User = () => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const _token = useSelector(currentToken);
  const userData = useSelector(currentUser);
  useEffect(() => {
    if (userData && _token) {
      const { user } = userData;
      setUser(user);
      setToken(_token);
    } else {
      setUser(null);
      setToken(null);
    }
  }, [_token, userData]);
  return (
    <Suspense fallback={<Spin />}>
      <Space direction="horizontal" align="center" size={'middle'}>
        {token && user ? (
          <UserInfo user={user.name} userData={userData}></UserInfo>
        ) : (
          <Fragment>
            <Login />
            <Register />
          </Fragment>
        )}
      </Space>
    </Suspense>
  );
};

const SearchContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const _Search = useRef(null);
  const [value, setValue] = useState(
    localStorage.getItem('SearchKeyword') || ''
  );

  // const KeyWord = useSelector(currentKeyword);

  const dispatch = useDispatch();

  const onSearch = (value) => {
    if (!value) {
      return message.error('keyword is required');
    }
    dispatch(setKeyword(value));
    navigate(`/search?keyword=${value}`);
  };

  const hanldChange = () => {
    setValue(_Search.current.input.value);
  };

  useEffect(() => {
    if (location.pathname !== '/search') {
      localStorage.setItem('SearchKeyword', '');
      return setValue('');
    }
  }, [location]);
  return (
    <Search
      addonBefore={<SearchIcon />}
      enterButton={<EnterIcon />}
      ref={_Search}
      placeholder={t('searchTips')}
      onSearch={onSearch}
      value={value}
      onChange={hanldChange}
      className={'search-input'}
      style={{
        width: 265,
        height: 32,
      }}
    />
  );
};

const LaugaugeButton = () => {};

export {
  NavLink,
  NavList,
  Logo,
  Login,
  User,
  Register,
  SearchContainer,
  LaugaugeButton,
};
